import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { supabase } from "../supabaseClient";
import { Loader2, CheckCircle2, ArrowRight, ArrowLeft } from "lucide-react";
import "../styles/GetQuote.css";
import TopBar from "../components/TopBar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const GetQuote = () => {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  // Form State
  const [formData, setFormData] = useState({
    coverage_type: "",
    entity_name: "",
    valuation: "",
    email: "",
    requirements: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectCoverage = (type) => {
    setFormData({ ...formData, coverage_type: type });
    setStep(2);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { error } = await supabase
      .from("quotes")
      .insert([formData]);

    if (error) {
      alert("Error: " + error.message);
    } else {
      setSubmitted(true);
    }
    setLoading(false);
  };

  const containerVars = {
    hidden: { opacity: 0, x: 20 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
    exit: { opacity: 0, x: -20, transition: { duration: 0.3 } },
  };

  return (
    <div className="quote-page-root">
      <TopBar />
      <Navbar />
      
      <div className="quote-light-root">
        <main className="quote-container">
          <header className="quote-header">
            <span className="eyebrow">Step {step} of 3</span>
            <h1>Request a <span className="serif-accent">Bespoke Quote.</span></h1>
            <p className="header-sub">Tailored risk protection for your assets and enterprise.</p>
          </header>

          <div className="quote-grid">
            <div className="quote-form-area">
              <AnimatePresence mode="wait">
                {submitted ? (
                  <motion.div key="success" variants={containerVars} initial="hidden" animate="visible" className="success-state">
                    <CheckCircle2 size={64} className="text-azure" />
                    <h2>Request Submitted</h2>
                    <p>Our underwriters are reviewing your details. Expect a proposal via email within 2 hours.</p>
                    <button onClick={() => window.location.reload()} className="btn-finish">New Quote</button>
                  </motion.div>
                ) : (
                  <>
                    {step === 1 && (
                      <motion.div key="step1" variants={containerVars} initial="hidden" animate="visible" exit="exit" className="step-content">
                        <h2 className="step-title">Select Coverage Type</h2>
                        <div className="option-grid">
                          {["Corporate Risk", "Private Wealth", "Life & Health", "Asset Protection"].map((item) => (
                            <button 
                              key={item} 
                              className={`option-card ${formData.coverage_type === item ? 'active' : ''}`}
                              onClick={() => handleSelectCoverage(item)}
                            >
                              {item}
                            </button>
                          ))}
                        </div>
                      </motion.div>
                    )}

                    {step === 2 && (
                      <motion.div key="step2" variants={containerVars} initial="hidden" animate="visible" exit="exit" className="step-content">
                        <h2 className="step-title">Tell us about you</h2>
                        <div className="input-stack">
                          <div className="rni-floating-group">
                            <input type="text" name="entity_name" placeholder=" " required onChange={handleChange} value={formData.entity_name} />
                            <label>Full Name / Company Name</label>
                          </div>
                          <div className="rni-floating-group">
                            <input type="number" name="valuation" placeholder=" " required onChange={handleChange} value={formData.valuation} />
                            <label>Estimated Valuation (Ksh)</label>
                          </div>
                          <div className="btn-group">
                            <button className="btn-back" onClick={() => setStep(1)}><ArrowLeft size={16}/> Back</button>
                            <button className="btn-next" onClick={() => setStep(3)}>Next Step <ArrowRight size={16}/></button>
                          </div>
                        </div>
                      </motion.div>
                    )}

                    {step === 3 && (
                      <motion.div key="step3" variants={containerVars} initial="hidden" animate="visible" exit="exit" className="step-content">
                        <h2 className="step-title">Finalize Request</h2>
                        <div className="input-stack">
                          <div className="rni-floating-group">
                            <input type="email" name="email" placeholder=" " required onChange={handleChange} value={formData.email} />
                            <label>Contact Email</label>
                          </div>
                          <div className="rni-floating-group">
                            <textarea name="requirements" placeholder=" " rows="4" onChange={handleChange} value={formData.requirements}></textarea>
                            <label>Special Requirements</label>
                          </div>
                          <div className="btn-group">
                             <button className="btn-back" onClick={() => setStep(2)}><ArrowLeft size={16}/> Back</button>
                             <button className="btn-finish" onClick={handleSubmit} disabled={loading}>
                                {loading ? <Loader2 className="rni-spin" /> : "Submit for Review"}
                             </button>
                          </div>
                        </div>
                      </motion.div>
                    )}
                  </>
                )}
              </AnimatePresence>
            </div>

            <aside className="quote-sidebar">
              <div className="trust-card">
                <h3>Why Rift?</h3>
                <ul>
                  <li><span>✓</span> Direct Claims Advocacy</li>
                  <li><span>✓</span> 45+ Years of Expertise</li>
                  <li><span>✓</span> Global Reinsurance Access</li>
                </ul>
              </div>
              <div className="support-card">
                <p>Need urgent help?</p>
                <a href="tel:+254721498898" className="phone-link">+254 721 498898</a>
              </div>
            </aside>
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default GetQuote;